import React from 'react'

import Tool from '~/models/tool'
import VisFile from '~/models/file'

import { sortModelsWithUpdatedAt } from '~/common/utils/sort'
import FileRow from '~/components/app/modules/file/FileRow'
import ToolRow from '~/components/app/modules/tool/list/ToolRow'
import RowList from '~/components/atoms/row/RowList'
import { RowBaseLayoutSize } from '~/components/molecules/row/content/RowBaseLayout'

interface Props {
  tools: Tool[]
  files: VisFile[]
  size?: RowBaseLayoutSize
}

const ToolFileList = ({tools, files, size = null}: Props) => {
  const models = sortModelsWithUpdatedAt([...tools, ...files])
  return (
    <RowList>
      {models && models.map((model: Tool|VisFile) =>
        (model as VisFile).is_directory === undefined ?
          <ToolRow key={'tool' + model.id} tool={model} size={size}/> :
          <FileRow key={'file' + model.id} file={model as VisFile} size={size}/>
      )}
    </RowList>
  )
}

export default ToolFileList
